import { NgModule } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgbModule, NgbCarouselConfig, NgbModalConfig, NgbToastModule, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { AuthGuard } from './_guards/auth.guard';
import { AlertComponent } from './_directives/alert.component';
import { AlertService } from './_services/alert.service';
import { AuthService } from './_services/auth.service';

// Routing
import { routing } from './app.routing';

// Components
import { AppComponent } from './app.component';

import { SettingsModule } from './_layout/settings/settings.module';
import { ThemeSettingsConfig } from './_layout/settings/theme-settings.config';
import { MenuSettingsConfig } from './_layout/settings/menu-settings.config';

import { HeaderComponent } from './_layout/header/header.component';
import { VerticalComponent as HeaderVerticalComponent } from './_layout/header/vertical/vertical.component';
import { HorizontalComponent as HeaderHorizontalComponent } from './_layout/header/horizontal/horizontal.component';
import { FullLayoutNavbarComponent } from './_layout/header/full-layout-navbar/full-layout-navbar.component';

import { FooterComponent } from './_layout/footer/footer.component';
import { NavigationComponent as AppNavigationComponent } from './_layout/navigation/navigation.component';

import { PublicLayoutComponent } from './_layout/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './_layout/private-layout/private-layout.component';

import { LoginComponent } from './login';

import { ChangelogComponent } from './changelog/changelog.component';

import { NavbarService } from './_services/navbar.service';
import { VerticalnavComponent } from './_layout/navigation/verticalnav/verticalnav.component';
import { HorizontalnavComponent } from './_layout/navigation/horizontalnav/horizontalnav.component';
import { NgxEditorModule } from 'ngx-editor';
// perfect scroll bar
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
// spinner
import { NgxSpinnerModule } from 'ngx-spinner';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { DeviceDetectorService } from './_services/device-detector.service';
import { RouterModule } from '@angular/router';
import { CustomizerComponent } from './_layout/customizer/customizer.component';
import { PartialsModule } from './content/partials/partials.module';
import { BreadcrumbModule } from './_layout/breadcrumb/breadcrumb.module';
import { DataApiService } from './_services/data.api';
import { HorizontalCustomizerComponent } from './_layout/customizer/horizontal-customizer/horizontal-customizer.component';
import { BlockTemplateComponent } from './_layout/blockui/block-template.component';
import { BlockUIModule } from 'ng-block-ui';
import { MatchHeightModule } from './content/partials/general/match-height/match-height.module';
import { FullLayoutComponent } from './_layout/full-layout/full-layout.component';
import { HammaddeComponent } from './hammadde/hammadde.component';
import { AddhammaddeComponent } from './hammadde/addhammadde/addhammadde.component';
import { ToastrModule } from 'ngx-toastr';
import { CompoundComponent } from './compound/compound.component';
import { AddcompoundComponent } from './compound/addcompound/addcompound.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CategoryComponent } from './category/category.component';
import { AddcategoryComponent } from './category/addcategory/addcategory.component';
import { PropertydefComponent } from './definition/propertydef/propertydef.component';
import { AddpropertyComponent } from './definition/propertydef/addproperty/addproperty.component';
import { ReportdefComponent } from './definition/reportdef/reportdef.component';
import { ReportsComponent } from './reports/reports.component';
import { NewreportComponent } from './reports/newreport/newreport.component';
import { AllergenComponent } from './allergen/allergen.component';
import { AddallergenComponent } from './allergen/addallergen/addallergen.component';
import { FunctionsComponent } from './functions/functions.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NoealComponent } from './reports/newreport/noeal/noeal.component';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { JwtInterceptor } from './_services/jwt-interceptor';
import { SuitableComponent } from './reports/newreport/suitable/suitable.component';
import { ForgetPasswordComponent } from './login/forget-password/forget-password.component';
import { EditProductComponent } from './reports/edit-product/edit-product.component';
@NgModule({
    imports: [
        BrowserModule,
        PartialsModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        MatchHeightModule,
        BreadcrumbModule,
        NgbModule,
        NgSelectModule,
        UiSwitchModule,
        NgbTypeahead,
        NgxEditorModule,
         routing,
        // Settings modules
        SettingsModule.forRoot(ThemeSettingsConfig, MenuSettingsConfig),
        PerfectScrollbarModule,
        NgxSpinnerModule,
        LoadingBarRouterModule,
        BlockUIModule.forRoot({
          template: BlockTemplateComponent
        }),
        ToastrModule.forRoot({
          timeOut: 3000,
          positionClass: 'toast-top-right',
          preventDuplicates: true
      }),
    ],
    declarations: [							
        AppComponent,
        PublicLayoutComponent,
        PrivateLayoutComponent,
        HeaderComponent,
        FullLayoutNavbarComponent,
        HeaderHorizontalComponent,
        HeaderVerticalComponent,
        FooterComponent,
        AppNavigationComponent,
        AlertComponent,
        LoginComponent,
        ChangelogComponent,
        VerticalnavComponent ,
        HorizontalnavComponent ,
        CustomizerComponent,
        HorizontalCustomizerComponent,
        BlockTemplateComponent,
        FullLayoutComponent,
    
      HammaddeComponent,
      AddhammaddeComponent,
      CompoundComponent,
      AddcompoundComponent,
      CategoryComponent,
      AddcategoryComponent,
      PropertydefComponent,
      AddpropertyComponent,
      ReportdefComponent,
      ReportsComponent,
      NewreportComponent,
      AllergenComponent,
      AddallergenComponent,
      FunctionsComponent,
      NoealComponent,
      PasswordChangeComponent,
      SuitableComponent,
      ForgetPasswordComponent,
      EditProductComponent
   ],
    providers: [
        AuthGuard,
        AlertService,
        NavbarService,
        DeviceDetectorService,
        DataApiService,
        AuthService,
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: HammerGestureConfig
        },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        NgbCarouselConfig,
        NgbModalConfig,
    ],
    entryComponents: [
      BlockTemplateComponent,
      AddhammaddeComponent,
      AddcompoundComponent,
      AddcategoryComponent,
      AddpropertyComponent,
      AddallergenComponent,
      NoealComponent,
      PasswordChangeComponent,
      SuitableComponent,
      ForgetPasswordComponent
    ],
    bootstrap: [AppComponent],
    exports: [RouterModule]
})

export class AppModule {

}
